"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _AvailableProducts = _interopRequireDefault(require("./AvailableProducts"));
var _PurchasedProducts = _interopRequireDefault(require("./PurchasedProducts"));
var _TransactionHistory = _interopRequireDefault(require("./TransactionHistory"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Dashboard = /*#__PURE__*/function (_PureComponent) {
  function Dashboard() {
    (0, _classCallCheck2["default"])(this, Dashboard);
    return _callSuper(this, Dashboard, arguments);
  }
  (0, _inherits2["default"])(Dashboard, _PureComponent);
  return (0, _createClass2["default"])(Dashboard, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AvailableProducts["default"], {
        isMasterSite: this.props.isMasterSite,
        hasBanking: this.props.hasBanking,
        whitelabel: this.props.whitelabel,
        member: this.props.member,
        purchasedProducts: this.props.purchasedProducts,
        availableProducts: this.props.availableProducts,
        selectProduct: this.props.selectProduct,
        loading: this.props.loading
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: 30
        }
      }), /*#__PURE__*/_react["default"].createElement(_PurchasedProducts["default"], {
        isMasterSite: this.props.isMasterSite,
        whitelabel: this.props.whitelabel,
        member: this.props.member,
        purchasedProducts: this.props.purchasedProducts,
        selectProduct: this.props.selectProduct,
        terminateProduct: this.props.terminateProduct,
        loading: this.props.loading
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: 20
        }
      }), /*#__PURE__*/_react["default"].createElement(_TransactionHistory["default"], {
        isMasterSite: this.props.isMasterSite,
        whitelabel: this.props.whitelabel,
        invoices: this.props.invoices,
        getInvoice: this.props.getInvoice,
        loading: this.props.loading,
        showingHistoryDefault: false,
        downloadPDFToBrowser: this.props.downloadPDFToBrowser,
        dispatch: this.props.dispatch
      }));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = Dashboard;